var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#EDF2F7",
    cx: 18.5,
    cy: 18.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.412 18.25l3.657-4.252a.582.582 0 01.911 0l.608.707a.835.835 0 010 1.06l-2.592 3.013 2.592 3.013a.835.835 0 010 1.06l-.608.706a.582.582 0 01-.911 0l-3.657-4.25a.83.83 0 010-1.058z",
    fill: "#90A9C0",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.4c23ddc269d63e72c07390386c789077.svg";
export { ForwardRef as ReactComponent };